var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgModalClose = function SvgModalClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.097 3.863A11.395 11.395 0 0011.98.5a11.395 11.395 0 00-8.117 3.363A11.395 11.395 0 00.5 11.98c0 3.069 1.192 5.946 3.363 8.117a11.395 11.395 0 008.117 3.363c3.069 0 5.946-1.193 8.117-3.363a11.395 11.395 0 003.363-8.117c0-3.069-1.193-5.947-3.363-8.117z",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.259 6.7a.679.679 0 00-.963 0l-4.316 4.317L7.664 6.7a.679.679 0 00-.963 0 .679.679 0 000 .963l4.316 4.316L6.7 16.296a.679.679 0 000 .963.685.685 0 00.479.202.664.664 0 00.479-.202l4.316-4.316 4.316 4.316a.685.685 0 00.479.202.656.656 0 00.479-.202.679.679 0 000-.963l-4.306-4.316 4.316-4.316a.679.679 0 000-.963z",
    fill: "#000"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModalClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modal-close.5d12c454.svg";
export { ForwardRef as ReactComponent };